export const userTypes = {
  LOGOUT: "LEARNER_LOGOUT",
};

export const logout = () => ({
  type: userTypes.LOGOUT,
});
